
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "spacer"
    }}>{`Spacer`}</h1>
    <p>{`The spacer component creates a flexible space that expands along the major axis of its containing flex layout.`}</p>
    <p>{`Under the hood, the spacer is simply a `}<inlineCode parentName="p">{`<div>`}</inlineCode>{` with the `}<inlineCode parentName="p">{`flex-basis`}</inlineCode>{` set to size relative to the baseline grid. This will allow you to create a space that will adapt vertically and horizontally in any flex-box layout.`}</p>
    <p>{`The default space is 1x to the baseline grid. Eg. 8px if the theme baseline is 8px. Setting the size to 2 would make it 1px, set it to 0.5 would make it 4px. In accordance with the design system rules: The size must be a multiple of 0.5, we do not allow sizes like 0.3.`}</p>
    <h3 {...{
      "id": "basic-example"
    }}>{`Basic Example`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Flex>
  <Button>Hello</Button>
  <Spacer />
  <Button>World</Button>
</Flex>
`}</code></pre>
    <h3 {...{
      "id": "in-a-row"
    }}>{`In a row`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Flex extend={{ flexDirection: 'row' }}>
  <Button>Hello</Button>
  <Spacer />
  <Button>World</Button>
</Flex>
`}</code></pre>
    <h3 {...{
      "id": "adapt-size-based-on-viewport"
    }}>{`Adapt size based on viewport`}</h3>
    <p>{`You can specify a media query (or use one from the theme) to control the size of the spacer for different viewports.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Flex>
  <Button>Hello</Button>
  <Spacer size={{ default: 4, '@media (max-width: 768px)': 8 }} />
  <Button>World</Button>
</Flex>
`}</code></pre>
    <h3 {...{
      "id": "props---spacer"
    }}>{`Props - Spacer`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`size`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`custom`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`1`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;